<mat-card class="overflow-hidden" (keydown.escape)="onEscapeKeydown($event)">
  <mat-card-header [class.no-planning-orders]="!hasPlanningOrders()">
    <mat-card-title class="flex-space-between flex-row full-width full-height">
      <h3>{{ 'PRODUCTION_ORDER.PRODUCTION_ORDER' | bmsTranslate: {count: 2} }}</h3>
      <div class="button-skeleton-wrapper standard-btn" *ngIf="!viewOnly">
        <button mat-icon-button class="mat-icon-action-button-lg-with-border add-production-orders" (click)="addProductionOrders()">
          <mat-icon svgIcon="add"></mat-icon>
        </button>
      </div>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <article *ngIf="hasPlanningOrders()">
      <ag-grid-angular
        class="ag-theme-vdw ag-auto-grow-grid-height"
        [gridOptions]="gridOptions"
        [rowData]="planningOrders"
        [getRowId]="getRowId"
        (rowDragEnter)="onRowDragEnter()"
        (rowDragLeave)="onRowDragLeave($event)"
        (rowDragMove)="onRowDragMove($event)"
        (rowDragEnd)="onRowDragEnd($event)"
      ></ag-grid-angular>
    </article>
  </mat-card-content>
</mat-card>
